export var SignalrMethod;
(function (SignalrMethod) {
    SignalrMethod["Unsubscribe"] = "Unsubscribe";
    SignalrMethod["Subscribe"] = "Subscribe";
    SignalrMethod["SetUid"] = "SetUid";
    SignalrMethod["GetAllOptionSymbols"] = "GetAllOptionSymbols";
    SignalrMethod["Get50StockSymbols"] = "Get50StockSymbols";
    SignalrMethod["GetAllStockSymbols"] = "GetAllStockSymbols";
})(SignalrMethod || (SignalrMethod = {}));
